// Constants.js
const config = {
  urls: {
    api_base_url: process.env.REACT_APP_API_BASE_URL || '/api', // Dev server
    api_messages_documentation: 'https://docs.elfo.com',
  },

  // REDUX STORE PERSIST CONFIG
  persistConfig: {
    key: 'A2P-PROD',
  },

  // SOCIAL LOGIN PLATFORMS
  social_login_platforms: {
    google: 1,
    linkedin: 3,
  },

  // SOCIAL LOGIN PLATFORM APP ID
  social_login_appId: {
    google: process.env.REACT_APP_GOOGLE,
    linkedin: process.env.REACT_APP_LINKEDIN,
  },

  // NOTIFY TIME TO STAY ON UI
  notify_time: 5000,

  // PAYMENT GATEWAYS
  payment_gateway: {
    stripe: {
      id: 2,
      label: 'Stripe',
    },
  },

  STRIPE_CLIENT: process.env.REACT_APP_STRIPE_CLIENT,

  // react google recaptcha section
  google_recaptcha_site_key: '6LeT3wIqAAAAAIuzaKosyF47I3nX-cZyoE0hGynf',
  google_recaptcha_secret_key: '6LeT3wIqAAAAADlk7kLo_ZBl21BUeKX-oyWZWJox',

  // Webhook URL
  webhookurl: 'https://docs.elfo.com/#webhook-url',
};


export default config;
